import React from 'react'
import styled from 'styled-components'
import MaisonMargiela from './MaisonMargiela'
import Givency from './Givency'
import Vogue from './Vogue'
import AmFar from './AmFar'
import Tiffany from './Tiffany'
import Elle from './Elle'
import LouisVuitton from './LouisVuitton'
import Campari from './Campari'
import GrandMarnier from './GrandMarnier'
import WMagazine from './WMagazine'
import EmilioPucci from './EmilioPucci'
import HarpersBazaar from './HarpersBazaar'
import CarolinaHerrera from './CarolinaHerrera'
import Interview from './Interview'

const StyledClientIcon = styled.li`
  height: 200px;
  width: 200px;
  padding: 5px;
  display: flex;
  margin: 20px;
`
const StyledClientIconsList = styled.ul`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-flow: row wrap;
  padding: 25px;
  width: 100%;
  background: black;
`

const Icons = [
  {
    name: 'maison',
    icon: MaisonMargiela,
  },
  {
    name: 'vogue',
    icon: Vogue,
  },
  {
    name: 'Tiffany',
    icon: Tiffany,
  },
  {
    name: 'Elle',
    icon: Elle,
  },
  {
    name: 'LouisVuitton',
    icon: LouisVuitton,
  },
  {
    name: 'Campari',
    icon: Campari,
  },
  {
    name: 'GrandMarnier',
    icon: GrandMarnier,
  },
  {
    name: 'amFar',
    icon: AmFar,
  },
  {
    name: 'EmilioPucci',
    icon: EmilioPucci,
  },
  {
    name: 'HarpersBazaar',
    icon: HarpersBazaar,
  },
  {
    name: 'WMagazine',
    icon: WMagazine,
  },
  {
    name: 'Givency',
    icon: Givency,
  },
  {
    name: 'CarolinaHerrera',
    icon: CarolinaHerrera,
  },
  {
    name: 'Interview',
    icon: Interview,
  },
]

const ClientIcons = ({
  className,
  style,
  iconClassName,
  iconStyle,
  id,
}) => {
  const ClientIcons = ({ className, style }) => Icons.map(({ name, icon: Icon }) =>
    <StyledClientIcon className={className} style={style} key={name}>
      <Icon style={{ width: 200, height: '100%', fill: '#eeefe6' }} />
    </StyledClientIcon>
  )

  return (
    <StyledClientIconsList id={id} className={className} style={style}>
      <ClientIcons className={iconClassName} style={iconStyle} />
    </StyledClientIconsList>
  )
}

export default ClientIcons
